import type { UserProfileResponse, UserResponse } from '@/interfaces/user';

import request from '../request';

/**
 * This function provides preloaded state to the redux store
 */
export const getUserData = async (): Promise<{
  data: UserResponse;
  profileData: UserProfileResponse | undefined;
}> => {
  const [userResponse, profileResponse] = await Promise.all([
    request({
      url: '/user',
    }),
    request({
      url: '/user/profile',
    }),
  ]);

  return {
    data: userResponse.data,
    profileData: profileResponse?.data,
  };
};
